import { createIcon } from '@chakra-ui/icons';

export const BellFilled = createIcon({
  displayName: 'BellFilled',
  viewBox: '0 0 25 24',
  path: [
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.25 10V8C20.25 5.87827 19.4071 3.84344 17.9069 2.34315C16.4066 0.842855 14.3717 0 12.25 0C10.1283 0 8.09344 0.842855 6.59315 2.34315C5.09285 3.84344 4.25 5.87827 4.25 8V10C4.22544 10.61 4.07539 11.2083 3.80922 11.7577C3.54305 12.3071 3.16647 12.7957 2.703 13.193C1.8702 13.9026 1.34858 14.9103 1.25 16C1.25 18.5 5.362 20 12.25 20C19.138 20 23.25 18.5 23.25 16C23.1514 14.9103 22.6298 13.9026 21.797 13.193C21.3335 12.7957 20.957 12.3071 20.6908 11.7577C20.4246 11.2083 20.2746 10.61 20.25 10Z"
        fill="currentColor"
      />
      <path
        d="M9.39502 21.9C9.58561 22.508 9.96532 23.0393 10.4788 23.4164C10.9924 23.7936 11.6129 23.997 12.25 23.997C12.8872 23.997 13.5077 23.7936 14.0212 23.4164C14.5347 23.0393 14.9144 22.508 15.105 21.9C14.211 21.966 13.261 22 12.25 22C11.239 22 10.289 21.968 9.39502 21.9Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
